export default "__VITE_ASSET__2173c004__"